import { urls } from "../constants";
import api from "./api";

const getOperators = async ({ page, limit }) => {
  try {
    const response = await api.get(urls.getOperators, {
      params: {
        page: page ? page : 1,
        limit: limit ? limit : 100
      }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const findByLaboratory = async ({ id }) => {
  try {
    const response = await api.get(`${urls.findByLaboratory}/${id}`);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getOperatorsFilter = async ({ text, page, limit }) => {
  try {
    const response = await api.get(urls.getOperators, {
      params: {
        text,
        page: page ? page : 1,
        limit: limit ? limit : 100
      }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const updateOperator = async ({ _id, operator }) => {
  try {
    const response = await api.put(`${urls.addOrUpdateOperator}/${_id}`, operator);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const addOperator = async ({ operator }) => {
  try {
    const response = await api.post(urls.addOrUpdateOperator, operator);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getOperatorProducts = async ({
  operatorId,
  page,
  limit,
  text,
  sort,
  laboratoryId,
}) => {
  try {
    const response = await api.get(urls.getOperatorProducts, {
      params: {
        operatorId,
        page: page ? page : 1,
        limit: limit ? limit : 100,
        text,
        sort,
        ...(laboratoryId ? { laboratoryId } : {}),
      }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const updateStatusAssignment = async ({
  assignmentId,
  status,
  failDescription,
}) => {
  try {
    const response = await api.put(`${urls.updateStatusAssign}/${assignmentId}`, { status, failDescription });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const assignLaboratories = async ({ _id, laboratories }) => {
  try {
    const response = await api.put(`${urls.assignLaboratories}/${_id}`, { laboratories });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getOperatorHistory = async ({ operatorId, page, limit, text, laboratoryId }) => {
  try {
    const response = await api.get(urls.getHistory, {
      params: {
        operatorId,
        page: page ? page : 1,
        limit: limit ? limit : 100,
        text,
        ...(laboratoryId ? { laboratoryId } : {}),
      }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getOperatorHistoryByStatus = async ({
  operatorId,
  page,
  limit,
  text,
  status,
  laboratoryId,
}) => {
  try {
    const response = await api.get(urls.getHistory, {
      params: {
        operatorId,
        page: page ? page : 1,
        limit: limit ? limit : 100,
        text,
        status,
        ...(laboratoryId ? { laboratoryId } : {}),
      }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const userServices = Object.freeze({
  getOperators,
  getOperatorsFilter,
  updateOperator,
  addOperator,
  getOperatorProducts,
  updateStatusAssignment,
  assignLaboratories,
  findByLaboratory,
  getOperatorHistory,
  getOperatorHistoryByStatus,
});

export default userServices;
